export default {
    userNavSection: {
        myPage: 'My page',
        myProfile: 'My profile',
        myTests: 'Assessments',
        myApplications: 'Applications',
        myFavorites: 'Favorites',
        internalResources: 'Resources',
        calendar: 'Calendar',
        documents: 'My Documents',
        referrals: 'Refer a friend',
        account: 'Account',
    },

    searchModule: {
        searchBar: {
            label: 'Search by title or keywords',
        },
        filters: {
            clearFilters: 'Clear filters',
        },
        filterLimit: {
            title: 'Filter limit reached',
            message: 'No more filters of this type can be selected',
        },
    },

    postingModule: {
        postingModule: {
            positions: 'Positions',
            estimatedCount: 'ca {count} of {totalCount}',
            knownCount: '{count} of {totalCount}',
            noMatchFound: "Couldn't find anything that matches your criteria",
        },
        postItem: {
            applyBefore: 'Application deadline',
            remote: 'Work remotely',
        },
        postCard: {
            deadline: 'Deadline',
        },
    },

    loginModule: {
        emailVerificationTip: 'It may take a few minutes for it to reach your inbox.',
        noEmail: 'No email? Please check your spam filter or:',
        tos: `By continuing, you agree to our <a href="https://gethighered.com/terms-and-conditions/" target="_blank">Terms and conditions</a> and acknowledge
                that you have read our <a href="https://gethighered.com/privacy-policy/" target="_blank">Privacy Policy</a> to learn how we collect, use,
                and share your data.`,

        logIn: 'Log in',

        socialAuthBtns: {
            continueWithFacebook: 'Continue with Facebook',
            continueWithGoogle: 'Continue with Google',
            continueWithLinkedIn: 'Continue with LinkedIn',
            continueWithWeChat: 'Continue with WeChat',
        },

        verifyEmail: {
            verifyYourEmail: 'Please verify your email',
            weSentAnEmailTo: 'We sent a verification to',
            continueToSignIn: 'Continue to Sign In',
            resendEmail: 'Resend verification link',
            newEmailSent: 'New email sent',
        },

        registerForm: {
            recommendation: `We recommend that you use your personal email and not your
            school email to ensure you have access to your data after you
            graduate.`,
            register: 'Register',
            passwordsNotMatch: 'The passwords do not match',
        },

        logInPaper: {
            useEmail: 'or use your email',
            noAccount: `Don't have an account?`,
            signUp: 'Sign up',
            logInToAccess: 'Log in to access this feature',

            showAllOptions: 'Show all login options',
            hideAllOptions: 'Show less',
        },

        logInForm: {
            logIn: 'Log in',
            forgotPassword: 'Forgot password?',
        },

        forgotPassword: {
            title: 'Request password reset',
            description: `No worries - everyone forgets their password from time to time.
                Enter your email below to reset your password`,
            resetPassword: 'Reset password',

            emailSentTitle: 'Your help is on its way!',
            emailHasBeenSent: `An email has been sent to
                            <br>
                            <strong>{email}</strong>
                            <br>
                            with instructions on how to reset your password. Please check your
                            inbox.`,

            noEmail: 'No email?',
            sendEmailOneMoreTime: 'Send email one more time',

            resendErrorTitle: 'Error during recovering password',
            resendErrorMessage: 'Was not able to send recover-password email. Maybe wrong email?',
        },
    },

    schoolVerification: {
        schoolNotFound: `We couldn't find your school in our database.`,
        schoolNotFoundDoubleCheck: 'Please double-check and select the correct one from the list.',
        schoolNotFoundDescription: `Selecting the correct school allows you to access exclusive jobs and events available only to your institution. Please check spelling and abbreviations.`,
        findMySchool: 'Find my school',
        notYetVerified: 'University affiliation not yet verified.',
        verificationPending: 'Verification pending',

        verificationPendingDescription:
            'Highered is verifying your request. You will be contacted by email when verification is complete. ',
        verificationPendingWithEmailDescription:
            'We sent you an email regarding verification for {schoolName} at {email}. Please check your email.',
        notYetVerifiedDescription:
            ' To access {schoolName} specific features like exclusive job postings, events and most importantly be recognized as a high-quality candidate, please verify your affiliation.',

        statusTooltips: {
            ignored:
                'By clicking on the icon, you are acknowledging the need for verification. You will then have access to specific features exclusive to {schoolName} and most importantly are recognized as a high-quality candidate.',
            unverified:
                'Your university affiliation is not yet verified. To access exclusive features, simply verify your affiliation.',
            pending: 'Your university affiliation is pending.',
            verified:
                'As a verified {schoolName} talent, you enjoy access to exclusive job postings, events, and most importantly, recognition as a high-quality candidate.',
        },

        verify: 'Verify',
        resendEmail: 'Resend email',
        cancelVerification: 'Cancel verification',
        ignore: 'Ignore',
        not_now: 'Not Now',
        ignoreConfirmationTitle: 'Postpone verification',
        ignoreConfirmationText:
            'Are you sure you want to proceed? \r\n You need to be verified to access specific features like exclusive job postings and resources',

        indicator: {
            needVerification: {
                heading: 'University affiliation not yet verified.',
                linkText: 'Go to profile to finish affiliation.',
            },
            pending: {
                heading: 'University affiliation pending.',
                linkText: 'Check your e-mail or go to profile to finish affiliation.',
            },
            unlockContentText:
                'This will unlock exclusive opportunities and you will be recognized as a high-quality candidate.',
        },
    },

    termsAndConds: {
        termsAndConditions: 'Terms & Conditions',
        privacyPolicy: 'Privacy policy',
        talentPanel: 'School/Employer?',
        enjoyingHighered: 'Enjoying Highered?',
    },

    favoriteModule: {
        favoriteCard: {
            deleted: 'Deleted',
            deletedTitle: 'This position is no longer available',
        },
    },
    pageNotFound: {
        header: '404',
        description: 'Looks like the page you were looking for is no longer here.',
        goToHome: 'Go to home page',
        contactus: 'Contact us',
    },
    chat: {
        liveNow: 'Live on chat now!',
        seeAll: 'All',
        schoolSpecificChats: 'Quick access',
        help: 'Need help?',
        chatExistsLabel: 'Chat exists',
    },
    countdown: {
        day: 'day',
        days: 'days',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        second: 'second',
        seconds: 'seconds',
    },
};
